import { atom } from "jotai";

export const loginModalAtom = atom(false);

// to track if a guest is booking a campaign
export const isBookingState = atom(false);
